import { render, staticRenderFns } from "./arrow-return.vue?vue&type=template&id=727baee0&scoped=true&lang=pug&"
import script from "./arrow-return.vue?vue&type=script&lang=js&"
export * from "./arrow-return.vue?vue&type=script&lang=js&"
import style0 from "./arrow-return.vue?vue&type=style&index=0&id=727baee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727baee0",
  null
  
)

export default component.exports